export const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateField = (field: string) => ({
  type: UPDATE_FIELD,
  payload: field,
});
